import ShareIcon from "@mui/icons-material/Share";

const Share = (props: any) => {
  return <ShareIcon {...props} />;
};

export default Share;
